import Sidebar from "@web-ui/components/Sidebar";
import type { NavigationItem } from "@web-ui/types/navigation";

/**
 * The console's sidebar: the kit's Sidebar (web-ui/components/Sidebar) with the brand switcher in
 * its top slot instead of the logo link (a menu cannot sit inside a link). Same widths, surfaces,
 * sliding pill, phone drawer and theme switch as every app on the kit. Which group is open is the
 * navigation's call (navigation.ts), so the Library and Settings never both hold the sidebar open.
 */
export function ConsoleSidebar({ top, navigation, open, onClose }: { top: React.ReactNode; navigation: NavigationItem[]; open: boolean; onClose: () => void }) {
  return <Sidebar navigation={navigation} top={top} visibleSidebar={open} onCloseSidebar={onClose} />;
}
